import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { scrollToElement } from '@lib/scroller';

export default class IndependentReviewContent extends Component {
  static propTypes = {
    reviewContentMarkup: PropTypes.string,
  };

  state = {
    isCollapsed: true,
  };

  toggleContentCollapsed = () => {
    if (!this.state.isCollapsed) {
      this.scrollToReviewTop();
    }
    this.setState({ isCollapsed: !this.state.isCollapsed });
  };

  scrollToReviewTop = () => {
    var independentReviewPanel = document.querySelector(
      '[data-element=independent-review]',
    );
    scrollToElement(independentReviewPanel);
  };

  render() {
    return (
      <div>
        <div
          className={classNames('ac-independent-review__content', {
            'ac-independent-review__content--collapsed': this.state.isCollapsed,
          })}
          dangerouslySetInnerHTML={{ __html: this.props.reviewContentMarkup }}
        />
        <button
          className="ch-btn ch-btn--block ch-btn--sm ch-btn--link ac-independent-review__show-more js-off--hide"
          onClick={this.toggleContentCollapsed}
          type="button"
        >
          {this.state.isCollapsed ? 'Show more' : 'Show less'}
        </button>
      </div>
    );
  }
}
